module.exports = {
      id: "prothomalo-com-usage",
      viewBox: "0 0 200 27",
      url: "/" + "sprite-a402f8ffc4310bc2e096ed6c94b22ccb.svg#prothomalo-com",
      toString: function () {
        return this.url;
      }
    }